import { QueryClientProvider } from 'react-query';

// Components
import { AppRouter } from './components/routes';

// Libs
import { queryClient } from './lib';

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  );
};

export default App;
